import { Dispatch, SetStateAction } from "react";
import { IntervalType } from "./AnalyticsDashboard";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";

type IntervalToggleButtonProps = {
	interval: IntervalType;
	setInterval: Dispatch<SetStateAction<IntervalType>>;
};

export default function IntervalToggleButton({
	interval,
	setInterval,
}: IntervalToggleButtonProps) {
	return (
		<ToggleButtonGroup
			color="primary"
			value={interval}
			exclusive
			onChange={(event, newInterval) =>
				newInterval !== null && setInterval(newInterval)
			}
			aria-label="Platform"
		>
			<ToggleButton value="month" aria-label="monthly">
				Monthly
			</ToggleButton>
			<ToggleButton value="year" aria-label="yearly">
				Yearly
			</ToggleButton>
		</ToggleButtonGroup>
	);
}
